import { yup } from '@framework/validation/initYup.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleType } from '../../IRuleType.ts';
import { NeedSignRuleComponent } from './NeedSignRuleComponent.tsx';

const configValidator = yup
  .object({
    value: yup.boolean().notRequired().label('Richiede Firma'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown()
  .nullable();

export const NeedSignRule: IRuleType<yup.InferType<typeof configValidator>> = {
  type: RuleType.NeedSign,
  name: 'Richiede firma',
  configComponent: NeedSignRuleComponent,
  configValidator,
  validator: schema => schema,
};
